import { MountingCalcInput, MountingCalcResult, PanelBlock, PostProcessor } from '../types'

export abstract class PostProcessorAbstract implements PostProcessor {
  protected input: MountingCalcInput
  protected block: PanelBlock

  constructor(input: MountingCalcInput, block: PanelBlock) {
    this.input = input
    this.block = block
  }

  abstract process(result: MountingCalcResult): MountingCalcResult
}
